import { Axios } from "../Axios";

export const getUserMessages = async (userId) => {
  console.log("getUserMessages", userId);
  return (await Axios.get(`/message/received-messages/${userId}`)).data;
};
